import React from 'react';
import { IconDownload, IconPlus, IconUpload } from '@tabler/icons-react';

const ActionBarCpanelTenantComp = ({ showFormAdd, showFormImport, showFormExport }) => (
  <div className="cpanel-action-bar d-flex align-items-center gap-2 py-1 flex-wrap">
    <button type="button" className="btn btn-sm btn-primary" onClick={showFormAdd}>
      <IconPlus size={16} className="me-1" />
      Tambah Tenant
    </button>
    <button type="button" className="btn btn-sm btn-light-primary" onClick={showFormImport}>
      <IconUpload size={16} className="me-1" />
      Impor Tenant
    </button>
    <button type="button" className="btn btn-sm btn-light-success" onClick={showFormExport}>
      <IconDownload size={16} className="me-1" />
      Ekspor Tenant
    </button>
  </div>
);

export default ActionBarCpanelTenantComp;
